exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button-add-new-card {\n  min-width: 180px;\n  padding-top: 15px!important;\n  padding-bottom: 15px!important;\n}\n", ""]);

// exports
